import { type ILogger } from '@cian/logger';

import { type IChipsOption } from 'shared/models/ChipsOption';

import { type IChipsDataService } from '../IChipsDataService';

/**
 * @description Сервис для работы с данными для чипов
 * @param items - Массив элементов
 * @example
 * const chipsDataService = new ChipsDataService(items);
 * const defaultItem = chipsDataService.defaultItem;
 * const activeItem = chipsDataService.getActiveItem('2021');
 */
export class ChipsDataService<T extends { chipsOption: IChipsOption }> implements IChipsDataService<T> {
  public readonly items: T[];
  public readonly chipsOptions: T['chipsOption'][];

  public constructor(items: T[]) {
    this.items = items;
    this.chipsOptions = items.map(item => item.chipsOption);
  }

  public get defaultItem(): T {
    return this.items[0];
  }

  public getActiveItem(value: string, logger: ILogger): T {
    let activeItem = this.items.find(item => item.chipsOption.value === value);

    if (!activeItem) {
      logger.error(`Активный элемент не найден для значения: ${value}`, {
        domain: this.constructor.name,
        items: JSON.stringify(this.items),
        method: 'getActiveItem',
      });

      activeItem = this.defaultItem;
    }

    return activeItem;
  }
}
